export enum Score {
  CLV = "clv",
  CHURN = "churn",
}



// WEBPACK FOOTER //
// ./src/types/Score.tsx